import axios from "axios";
import { useUserStore } from "@/stores/user";
import { message } from "ant-design-vue/es";

axios.defaults.withCredentials = false;

// 创建 axios 实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API || "", // API 的 base_url
  timeout: 5000, // 请求超时时间
  headers: { "Content-Type": "application/json" },
});

// 请求拦截器
service.interceptors.request.use(
  (config) => {
    console.log("config", config);
    // 在请求发送之前做一些处理，比如在 header 中添加 token
    const user = useUserStore();
    if (user.cmotoken && config.url.indexOf("aliyuncs.com/upload") < 0) {
      config.headers["Authorization"] = `Bearer ${user.cmotoken}`;
    }
    return config;
  },
  (error) => {
    // 处理请求错误
    console.error(error);
    return Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    // 处理响应错误
    console.error(46, error);
    if (error.status) {
      switch (error.status) {
        case 401: {
          const user = useUserStore();
          // 清除用户信息
          user.clearUserInfo();
          // 跳转到登录页
          window.location.href = "/login";
          message.error("登录异常，请重新登录");
          return Promise.reject(error.response.data);
        }
        case 500:
          return Promise.reject(error.response.data);
        default:
          return Promise.reject(error);
      }
    }
    return Promise.reject(error);
  }
);

export default service;
